const mutations = {
  TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE(state, value) {
    state.isVerticalNavMenuActive = value
  },
  TOGGLE_REDUCE_BUTTON(state, val) {
    state.reduceButton = val
  },
  UPDATE_MAIN_LAYOUT_TYPE(state, val) {
    state.mainLayoutType = val
  },
  UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN(state, val) {
    state.verticalNavMenuItemsMin = val
  },
  UPDATE_VERTICAL_NAV_MENU_WIDTH(state, width) {
    state.verticalNavMenuWidth = width
  },

  ARRANGE_STARRED_PAGES_LIMITED(state, list) {
    const starredPagesMore = state.starredPages.slice(10)
    state.starredPages = list.concat(starredPagesMore)
  },
  SET_PRODUCTS(state, orderList) {
    state.orderList = orderList
  },
  TOGGLE_CONTENT_OVERLAY(state, val) {
    state.bodyOverlay = val
  },
  UPDATE_PRIMARY_COLOR(state, val) {
    state.themePrimaryColor = val
  },
  UPDATE_THEME(state, val) {
    state.theme = val
  },
  UPDATE_WINDOW_WIDTH(state, width) {
    state.windowWidth = width
  },
  UPDATE_WINDOW_SCROLL_Y(state, val) {
    state.scrollY = val
  },


  UPDATE_USER_INFO(state, payload) {
    let userInfo = JSON.parse(localStorage.getItem("userInfo")) || state.AppActiveUser
    for (const property of Object.keys(payload)) {
      if (payload[property] != null) {
        state.AppActiveUser[property] = payload[property]

        userInfo[property] = payload[property]
      }
    }
    localStorage.setItem("userInfo", JSON.stringify(userInfo))
  },
  TOGGLE_ITEM_IN_WISH_LIST(state, item) {
    const index = state.wishList.findIndex(i => i.objectID == item.objectID)
    if (index < 0) {
      state.wishList.push(item)
    } else {
      state.wishList.splice(index, 1)
    }
  },
  REMOVE_ITEM_FROM_CART(state, item) {
    const index = state.cartItems.findIndex(i => i.objectID == item.objectID)
    if (index > -1) {
      state.cartItems.splice(index, 1)
    }
  },
  ADD_ITEM_IN_CART(state, item) {
    var str = "";
    if (item.mealOption) {
      item.mealOption.forEach(e => {
        e.forEach(f => {
          str += f.name + "(" + f.price + ")"
        })
        str += "|"
      })
      item['mealOption'] = str;
    }

    item["brand_chi"] = state.selectedRestaurant[0].name_chi ? state.selectedRestaurant[0].name_chi : "";
    item["brand_eng"] = state.selectedRestaurant[0].name_english ? state.selectedRestaurant[0].name_english : "";
    state.cartItems.push(Object.assign({}, item))
  },
  UPDATE_ITEM_QUANTITY(state, payload) {
    state.cartItems[payload.index].quantity = payload.quantity
  },
  ADD_REST_IN_LIST(state, item) {
    state.selectedRestaurant.push(Object.assign({}, item))
  },
  REMOVE_REST_IN_LIST(state, item) {
    const index = state.selectedRestaurant.findIndex(i => i.objectID == item.objectID)
    if (index > -1) {
      state.selectedRestaurant.splice(index, 1)
    }
  },
  REMOVE_REST_LIST(state) {
    state.selectedRestaurant.splice(0, state.selectedRestaurant.length);
    state.cartItems.splice(0, state.cartItems.length);
  },
  REMOVE_CURR_ITEM(state) {
    state.currentItem = {};
  },
  TOGGLE_REST_IN_WISH_LIST(state, item) {
    const index = state.wishRestaurant.findIndex(i => i.objectID == item.objectID)
    if (index < 0) {
      state.wishRestaurant.push(item)
    } else {
      state.wishRestaurant.splice(index, 1)
    }
  },
  TOGGLE_REST_IN_REST_LIST(state, item) {
    const index = state.selectedRestaurant.findIndex(i => i.objectID == item.objectID)
    if (index < 0) {
      state.selectedRestaurant.push(item)
    } else {
      state.selectedRestaurant.splice(index, 1)
    }
  },
  TOGGLE_CURR_ITEM(state, item) {
    state.currentItem = item;
  },

  TOGGLE_MEAL_IN_MEAL_LIST(state, item) {
    const index = state.cartItems.findIndex(i => i.objectID == item.objectID)
    if (index < 0) {
      state.cartItems.push(item)
    } else {
      state.cartItems.splice(index, 1)
    }
  },
  CLEAR_ORDER_LIST(state) {
    state.orderList.splice(0, state.orderList.length);
    state.orderDisplayList.splice(0, state.orderDisplayList.length);
  },
  CLEAR_ORDER_LIST_ADMIN(state) {
    state.orders.splice(0, state.orders.length);
  },
  calculatePerItem(item) {
    var price = 0

    item.orderOption.forEach(opt => {
      price += opt.price;
    })

    return price;
  },
  CHANEG_LANGUAGE(state, lang) {
    state.language = lang;
  },
  UPDATE_ORDER_SEARCH_LIST(state, item) {
    state.orderList.push(Object.assign({}, item))
    var resList = item.orderDetail.items;
    var strRes = "";
    resList.forEach(r => {
      var extra = "";
      if (r.orderOption)
        r.orderOption.forEach(e => {
          extra += e.name + "($" + e.price + ") ";
        })
      strRes = strRes + "- " + (r.brand_chi ? r.brand_chi : r.brand_eng) + ": " + (r.name_chi ? r.name_chi : r.name_eng) + (extra ? " 配 " + extra : "") + " x " + r.quantity + "\n"
    });
    strRes = strRes.replace('&', '%26')
    state.orderDisplayList.push({
      orderDetail: item.orderDetail,
      orderId: "#" + item.created_at.seconds.toString().substring(6, item.created_at.seconds.toString().length),
      orderRestaurant: strRes,
      orderPerson: item.fullName,
      orderAddress: item.address1 + "\n" + item.address2,
      orderPhone: item.mobileNum,
      remarks: item.remarks,
      paymentMethod: item.paymentMethod,
      updateTime: new Date(item.updated_at.seconds * 1000).toLocaleDateString() + ' ' + new Date(item.updated_at.seconds * 1000).toLocaleTimeString(),
      createTime: new Date(item.created_at.seconds * 1000).toLocaleDateString() + ' ' + new Date(item.created_at.seconds * 1000).toLocaleTimeString(),
      orderStatus: item.order_status,
      orderAmount: item.orderDetail.ttlPrice,
      deliverer: item.deliverer
    })
  },
  UPDATE_ORDER_SEARCH_LIST_ADMIN(state, item) {
    var resList = item.orderDetail.items;
    var strRes = "";
    var strResInt = "";
    var wtsappResStr = "";
    var wtsappResStrEng = "";
    var wtsappResStrChi = "";
    var wtsappResName = resList[0].brand_chi;
    var wtsappResNameEng = resList[0].brand_eng;

    if (!item.lang) {
      item['lang'] = 'zh'
    }
    resList.forEach(r => {
      var extra = "";
      var extraPrice = 0;
      if (!(r.categories)) {
        r['categories'] = r.categories
      }
      if (r.orderOption)
        r.orderOption.forEach(e => {
          extra += e.name + "($" + e.price + ") ";
          extraPrice += e.price;
        })
      // wtsappResName = wtsappResName + (r.brand_chi ? r.brand_chi : '') + ' ' + (r.brand_eng ? r.brand_eng : '');
      // strRes = strRes + "- " + (r.brand_chi ? r.brand_chi : '') + ' ' + (r.brand_eng ? r.brand_eng : '') + ": (" + (r.categories[0]) + ") " + (r.name_chi ? r.name_chi : '') + ' ' + (r.name_eng ? r.name_eng : '') + (extra ? " 配 " + extra : "") + " x " + r.quantity + "\n"
      // strResInt = strResInt + "- " + (r.brand_chi ? r.brand_chi : '') + ' ' + (r.brand_eng ? r.brand_eng : '') + ": (" + (r.categories[0]) + ") " + (r.name_chi ? r.name_chi : '') + ' ' + (r.name_eng ? r.name_eng : '') + (extra ? " 配 " + extra : "") + " x " + r.quantity + " (Total $" + (r.unit_price + extraPrice) + ")\n"
      strRes = strRes + "- " + "(" + (r.categories[0]) + ") " + (r.name_chi ? r.name_chi : '') + ' ' + (r.name_eng ? r.name_eng : '') + (extra ? " 配 " + extra : "") + " x " + r.quantity + "\n"
      strResInt = strResInt + "- " + "(" + (r.categories[0]) + ") " + (r.name_chi ? r.name_chi : '') + ' ' + (r.name_eng ? r.name_eng : '') + (extra ? " 配 " + extra : "") + " x " + r.quantity + " (Total $" + (r.unit_price * r.quantity + extraPrice * r.quantity) + ")\n"
    });
    resList.forEach(r => {
      if (!(r.categories)) {
        r['categories'] = r.categories
      }
      var extra = "";
      if (r.orderOption)
        r.orderOption.forEach(e => {
          extra += e.name;
        })

      wtsappResStrChi = wtsappResStrChi + "(" + (r.categories[0]) + ") -> " + (r.name_chi ? r.name_chi : '') + ' ' + (extra ? " 配 " + extra : "") + " x " + r.quantity + "%0a"
      wtsappResStr = wtsappResStr + "(" + (r.categories[0]) + ") -> " + (r.name_chi ? r.name_chi : '') + ' ' + (r.name_eng ? r.name_eng : '') + (r.name_english ? r.name_english : '') + (extra ? " 配 " + extra : "") + " x " + r.quantity + "%0a"
      wtsappResStrEng = wtsappResStrEng + "(" + (r.categories[0]) + ") -> " + (r.name_eng ? r.name_eng : '') + (r.name_english ? r.name_english : '') + ' ' + (extra ? " with " + extra : "") + " x " + r.quantity + "%0a"
    });
    state.orders.push({
      firebaseId: item.id,
      orderDetail: item.orderDetail,
      orderRestaurantWtsapp: wtsappResStr,
      orderRestaurantWtsappChi: wtsappResStrChi,
      orderRestaurantWtsappEng: wtsappResStrEng,
      orderRestaurantName: wtsappResName,
      orderRestaurantNameEng: wtsappResNameEng,
      orderId: "#" + item.created_at.seconds.toString().substring(6, item.created_at.seconds.toString().length),
      orderRestaurant: strRes,
      orderRestaurantInt: strResInt,
      orderLang: 'zh',
      orderPerson: item.fullName,
      orderAddress: item.address1 + "\n" + item.address2,
      orderPhone: item.mobileNum,
      orderDeliverer: item.deliverer,
      remarks: item.remarks,
      paymentMethod: item.paymentMethod,
      createTime: new Date(item.created_at.seconds * 1000).toLocaleDateString() + ' ' + new Date(item.created_at.seconds * 1000).toLocaleTimeString(),
      orderStatus: item.order_status,
      orderAmount: item.orderDetail.ttlPrice,
      remarksInt: item.remarksInt
    })
  },
}

export default mutations